<template>
  <div class="market-info-header">
    <h1
      class="market-info-header__title txt--bold txt--color-04 txt--26px txt--52px--l txt--height-34px txt--height-64px--l"
      v-text="title"
    />
    <div class="market-info-header__search">
      <base-search-input
        :value="value"
        size="s"
        :placeholder="placeholder"
        @input="handleSearch"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketInfoHeader',

  components: {
    BaseSearchInput: () =>
      import(/* webpackMode: "eager" */ '@/components/base/BaseSearchInput'),
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    withSearch: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    handleSearch (val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.market-info-header {
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  gap: toRem(10px);

  @include bp(l) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    display: flex;
    flex-grow: 1;
  }

  &__search {
    @include bp(l) {
      width: toRem(311px);
      max-width: 100%;
    }
  }
}
</style>
